module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/03-4c162d3e62d0516b3d086e8b7bb8b698.jpg";